import { render, staticRenderFns } from "./TranslatorFileInput.vue?vue&type=template&id=751ad116&scoped=true"
import script from "./TranslatorFileInput.vue?vue&type=script&lang=js"
export * from "./TranslatorFileInput.vue?vue&type=script&lang=js"
import style0 from "./TranslatorFileInput.vue?vue&type=style&index=0&id=751ad116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751ad116",
  null
  
)

export default component.exports